export const inspectTable_1 = [
  {
    content: `필요한 안전인력 확보<br/>
<span style='font-weight: normal;'>- 안전·보건관리 업무의 수행을 담당할 인력 확보</span><br/>
<span style='font-weight: normal;'>- 유해·위험요인의 점검과 위험징후 발생 시 대응 인력</span>`,
    isChecked: ``,
  },
  {
    content: `필요한 안전예산 편성 및 집행<br/>
<span style='font-weight: normal;'>- 안전·보건관리 업무의 수행을 위한 인력, 시설 및 장비 등의 확보유지 예산</span><br/>
<span style='font-weight: normal;'>- 유해·위험요인의 점검과 위험징후 발생 시 대응 예산</span>`,
    isChecked: ``,
  },
  {
    content: `아래 사항이 포함된 업무처리절차 마련 및 이행<br/>
<span style='font-weight: normal;'>- 유해·위험의 주기적인 점검</span><br/>
<span style='font-weight: normal;'>- 제보나 위험징후의 감지 등을 통해 발견된 유해위험요인을 확인한 결과 중대시민재해의 발생 우려가 있는 경우의 신고 및 조치</span><br/>
<span style='font-weight: normal;'>- 중대시민재해가 발생한 경우의 보고, 신고 및 조치</span><br/>
<span style='font-weight: normal;'>- 중대시민재해 원인조사에 따른 개선조치</span>`,
    isChecked: ``,
  },
  {
    content: `안전교육 실시 여부<br/>
<span style='font-weight: normal;'>- 안전·보건 관계 법령에 따라 의무적으로 실시해야 하는 교육의 실시 여부</span>`,
    isChecked: ``,
  },
  {
    content: `그 밖에 원료·제조물 관련 안전·보건 관리를 위해 환경부장관이 정하여 고시하는 사항</span><br/>
<span style='font-weight: normal;'>- 보건증 등 위생 관련 법적 필수사항 해당 시, 실시 여부</span>`,
    isChecked: ``,
  },
];

export const inspectTable_2 = [
  {
    content: `작업 전 건강상태를 확인함(감기, 설사, 손 상처자 등 조리금지)`,
    isChecked: ``,
  },
  {
    content: `위생복, 위생화, 앞치마, 위생모를 착용하고, 배식시에는 배식 전용기구, 마스크, 위생장갑을 사용하고 있음`,
    isChecked: ``,
  },
  {
    content: `유통기간 확인 및 선입·선출을 준수하고 있음`,
    isChecked: ``,
  },
  {
    content: `식재료 보관실은 항상 청결을 유지하고 있음`,
    isChecked: ``,
  },
  {
    content: `보존식 보존 및 관리기준을 준수하고 있음 (권고 사항임)`,
    isChecked: ``,
  },
  {
    content: `어류･육류･채소류를 취급하는 칼･도마는 각각 구분하여 사용하고 있음`,
    isChecked: ``,
  },
  {
    content: `식기류 및 조리기구의 세척, 소독을 철저히 하고 있음`,
    isChecked: ``,
  },
  {
    content: `식재료 검수일지를 작성하고 보관하고 있음 (권고 사항임)`,
    isChecked: ``,
  },
  {
    content: `세제, 소독제, 살충제에 라벨을 부착하고 분리보관하고 방충, 방서 등을 위한 조치 및 관리를 하고 있음`,
    isChecked: ``,
  },
  {
    content: `식재료의 입고날짜를 기록한 라벨을 부착하여 관리하고 있음`,
    isChecked: ``,
  },
];

export const inspectTable_3 = [
  {
    content: `조리장 바닥과 배수로에 물고임 및 냄새역류가 없도록 관리하고 있음`,
    isChecked: ``,
  },
  {
    content: `후드, 환풍기를 청결하게 관리하고 있음`,
    isChecked: ``,
  },
];
